import { render, staticRenderFns } from "./ExchangeRateSourceSpecEditor.yaml?vue&type=template&id=651f55d8&component"
import script from "./ExchangeRateSourceSpecEditor.yaml?vue&type=script&lang=ts&component"
export * from "./ExchangeRateSourceSpecEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports